import Spacing from "@jmc/solid-design-system/src/components/atoms/Spacing/Spacing";
import { Color } from "@jmc/solid-design-system/src/components/molecules/HeaderHero/HeaderHero";
import { ApplicationState } from "@redux/modules";
import { BottomContentState, clear } from "@redux/modules/bottomContent";
import isEqual from "lodash/isEqual";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

interface BottomContent {
    bottomContent: BottomContentState;
    lastSectionBackground: Color;
}

export const useBottomContent = (): BottomContent => {
    const bottomContent = useSelector((state: ApplicationState) => state.bottomContent, isEqual);

    return { bottomContent, lastSectionBackground: bottomContent?.lastSectionBackground };
};

export const LogicSpacing = (): JSX.Element => {
    const { lastSectionBackground, bottomContent } = useBottomContent();
    const dispatch = useDispatch();

    // Clear the bottom content when unmounting the component
    useEffect(() => {
        return () => {
            dispatch(clear());
        };
    }, [dispatch]);

    const hasIMRContentAbove = Boolean(
        bottomContent?.hasVisibleFootnotes || bottomContent?.hasVisibleSMPCs || bottomContent.hasVisibleAEPIDisclaimer,
    );

    const shouldUseCompactSpacing =
        (!bottomContent?.hasVisibleIMR && (hasIMRContentAbove || lastSectionBackground === Color.WHITE)) ||
        (lastSectionBackground !== Color.WHITE && bottomContent.hasVisibleIMR && !hasIMRContentAbove);

    const shouldUseExpandedSpacing =
        lastSectionBackground !== Color.WHITE && !bottomContent?.hasVisibleIMR && !hasIMRContentAbove;

    if (shouldUseCompactSpacing) {
        return <Spacing size="compact" />;
    }

    if (shouldUseExpandedSpacing) {
        return <Spacing size="expanded" />;
    }

    return null;
};

export default LogicSpacing;
